import type { Translations } from './de'

const pl: Translations = {
  'language.flag': '🇵🇱',
  'language.name': 'Polski',
  'navigation.home': 'Strona główna',
  'navigation.language': 'Język',
  'navigation.openMenu': 'Otwórz menu',
  'navigation.closeMenu': 'Zamknij menu',
  'navigation.skipToContent': 'Przejdź do treści',
  'categories.sightseeing.name': 'Atrakcje',
  'categories.sightseeing.heading': 'Najpopularniejsze atrakcje Augsburga',
  'categories.sightseeing.lead': 'Od światowego dziedzictwa UNESCO po Fuggerei: Augsburg ma do zaoferowania więcej, niż myślisz.',
  'categories.events.name': 'Wydarzenia',
  'categories.events.heading': 'Wszystkie wydarzenia w jednym miejscu',
  'categories.events.lead': 'Koncerty, targi, zwiedzanie z przewodnikiem: sprawdź, co dzieje się w tym tygodniu w Augsburgu.',
  'categories.blog.name': 'Aktualności',
  'categories.blog.heading': 'Wiadomości z Augsburga',
  'categories.blog.lead': 'Kulisy, historia miasta i bieżące tematy do czytania i opowiadania dalej.',
  'categories.emptyTitle': 'Na razie nic tu nie ma',
  'categories.emptyDescription': 'W tej sekcji nie ma jeszcze żadnych stron. Zajrzyj wkrótce.',
  'home.title': 'Witamy w Augsburgu',
  'home.intro': 'Wycieczka do miasta, podróż służbowa czy wizyta u rodziny: tutaj znajdziesz wszystkie ważne informacje na czas pobytu w Augsburgu.',
  'home.sightseeing.eyebrow': 'Miasto światowego dziedzictwa UNESCO',
  'home.sightseeing.title': 'Odkryj atrakcje',
  'home.sightseeing.lead': 'Od światowego dziedzictwa UNESCO po Fuggerei: Augsburg ma do zaoferowania więcej, niż myślisz.',
  'home.sightseeing.action': 'Odkryj teraz',
  'home.events.eyebrow': 'Co się dzieje w Augsburgu?',
  'home.events.title': 'Znajdź wydarzenia',
  'home.events.lead': 'Nie przegap już żadnego koncertu, pchlego targu ani festiwalu. Na naszej stronie wydarzeń zawsze jesteś na bieżąco.',
  'home.events.action': 'Wszystkie wydarzenia',
  'home.blog.eyebrow': 'Historie z miasta',
  'home.blog.title': 'Nowości i ciekawostki',
  'home.blog.lead': 'Tutaj znajdziesz wszystko, co warto wiedzieć o Augsburgu. Przyda się podczas twojej wizyty.',
  'home.blog.action': 'Do bloga',
  'home.language.eyebrow': 'Augsburg jest międzynarodowy',
  'home.language.title': 'Przełącz na swój język',
  'home.language.lead': 'Ta strona jest dostępna w wielu językach. Chcesz zmienić język?',
  'home.highlights.eyebrow': 'Wybrane dla ciebie',
  'home.highlights.title': 'Nasze rekomendacje',
  'home.highlights.lead': 'Na dobry początek zebraliśmy dla ciebie kilka najciekawszych miejsc w Augsburgu. Miłej lektury!',
  'search.placeholder': 'Szukaj...',
  'search.clear': 'Wyczyść wyszukiwanie',
  'search.label': 'Szukaj stron',
  'search.results': '{{count}} wyników dla „{{query}}”',
  'search.emptyTitle': 'Brak wyników',
  'search.emptyDescription': 'Nic nie znaleźliśmy dla tego wyszukiwania. Spróbuj innego słowa.',
  'pagination.label': 'Strony',
  'pagination.previous': 'Poprzednia strona',
  'pagination.next': 'Następna strona',
  'pagination.page': 'Strona {{page}}',
  'pagination.summary': '{{start}}–{{end}} z {{total}}',
  'page.back': 'Wstecz',
  'page.readMore': 'Dowiedz się więcej',
  'page.tableOfContents': 'Na tej stronie',
  'page.openInGoogleMaps': 'Otwórz w Mapach Google',
  'map.copyAddress': 'Kopiuj adres',
  'map.copied': 'Skopiowano',
  'map.copyFailed': 'Nie można skopiować',
  'map.routeInGoogleMaps': 'Trasa w Mapach Google',
  'map.zoomIn': 'Przybliż',
  'map.zoomOut': 'Oddal',
  'map.showAll': 'Pokaż wszystko',
  'attribution.toggle': 'Pokaż lub ukryj źródła',
  'map.gestures.windows': 'Użyj Ctrl + przewijania, aby przybliżyć mapę',
  'map.gestures.mac': 'Użyj ⌘ + przewijania, aby przybliżyć mapę',
  'map.gestures.mobile': 'Przesuwaj mapę dwoma palcami',
  'map.loading': 'Ładowanie mapy …',
  'map.failed': 'Nie udało się załadować mapy.',
  'map.showPlace': 'Pokaż {{name}} na mapie',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'ok. {{duration}} pieszo',
  'map.route.stops': 'Przystanki: {{count}}',
  'map.route.leg': '{{distance}} · ok. {{duration}}',
  'mapIcons.landmark': 'Atrakcja',
  'mapIcons.church': 'Kościół',
  'mapIcons.museum': 'Muzeum',
  'mapIcons.park': 'Park i przyroda',
  'mapIcons.viewpoint': 'Punkt widokowy',
  'mapIcons.cafe': 'Kawiarnia',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restauracja',
  'mapIcons.shop': 'Zakupy',
  'mapIcons.event': 'Miejsce wydarzeń',
  'mapIcons.transport': 'Transport',
  'mapIcons.place': 'Miejsce',
  'footer.imprint': 'Nota prawna',
  'footer.privacy': 'Polityka prywatności',
  'footer.mediaLicense': 'Prawa do zdjęć',
  'legal.bindingNote': 'To tłumaczenie ma charakter wyłącznie informacyjny. Prawnie wiążąca jest jedynie wersja niemiecka.',
  'imprint.provider.heading': 'Informacje zgodnie z § 5 DDG',
  'imprint.contact.heading': 'Kontakt',
  'imprint.contact.email': 'E-mail',
  'imprint.responsible.heading': 'Odpowiedzialny za treść zgodnie z § 18 ust. 2 MStV',
  'privacy.intro': 'Niniejsza polityka prywatności wyjaśnia, jakie dane osobowe są przetwarzane podczas odwiedzania tej strony.',
  'privacy.controller.heading': 'Administrator danych',
  'privacy.controller.text': 'Administratorem danych na tej stronie jest:',
  'privacy.hosting.heading': 'Hosting',
  'privacy.hosting.text': 'Ta strona jest hostowana przez zewnętrznego dostawcę usług hostingowych z siedzibą w Niemczech. Serwery znajdują się w Niemczech.',
  'privacy.serverLogs.heading': 'Pliki dziennika serwera',
  'privacy.serverLogs.text': 'Przy każdej wizycie na tej stronie serwer automatycznie zapisuje informacje przekazywane przez twoją przeglądarkę: adres IP, datę i godzinę żądania, otwartą stronę, ilość przesłanych danych, adres URL strony odsyłającej oraz przeglądarkę i system operacyjny. Dane te są niezbędne do bezpiecznego i stabilnego działania strony (art. 6 ust. 1 lit. f RODO) i są usuwane najpóźniej po 7 dniach.',
  'privacy.analytics.heading': 'Pomiar oglądalności',
  'privacy.analytics.text': 'Aby wiedzieć, które strony są czytane, sami liczymy odsłony stron, bez zewnętrznych usług i bez plików cookie. Gdy otwierasz stronę, twoja przeglądarka przekazuje naszemu serwerowi tylko jej adres. Dla każdego adresu, języka i dnia zapisujemy wyłącznie liczbę odsłon, osobno dla przeglądarek i programów automatycznych (robotów indeksujących), które rozróżniamy po identyfikatorze przeglądarki (user agent). Twój adres IP, identyfikator przeglądarki ani inne dane o tobie nie są w tym celu zapisywane; nie da się ustalić poszczególnych odwiedzających. Jeśli twoja przeglądarka wysyła sygnał „Global Privacy Control” lub „Do Not Track”, twoja wizyta nie jest liczona. Dane są usuwane po roku. Podstawą prawną jest art. 6 ust. 1 lit. f RODO; naszym prawnie uzasadnionym interesem jest ulepszanie tej strony.',
  'privacy.errorReports.heading': 'Raporty błędów',
  'privacy.errorReports.text': 'Jeśli podczas ładowania strony wystąpi błąd techniczny, do operatora automatycznie wysyłany jest e-mail z informacjami o nieudanym żądaniu. Może on zawierać twój adres IP, otwarty adres i dane o twojej przeglądarce. Raporty błędów służą wyłącznie do usuwania błędów (art. 6 ust. 1 lit. f RODO).',
  'privacy.cookies.heading': 'Pliki cookie',
  'privacy.cookies.text': 'Ta strona używa wyłącznie technicznie niezbędnych plików cookie, potrzebnych do obsługi twojej sesji i ochrony przed sfałszowanymi żądaniami (CSRF). Nie zawierają one danych do celów analitycznych ani reklamowych i są usuwane po zamknięciu przeglądarki. Podstawą prawną jest § 25 ust. 2 nr 2 TDDDG w związku z art. 6 ust. 1 lit. f RODO; zgoda nie jest wymagana. Nie są używane żadne zewnętrzne usługi analityczne ani śledzące; opisany wyżej pomiar oglądalności działa bez plików cookie.',
  'privacy.rights.heading': 'Twoje prawa',
  'privacy.rights.text': 'Masz prawo do:',
  'privacy.rights.access': 'dostępu do swoich zapisanych danych (art. 15 RODO)',
  'privacy.rights.rectification': 'sprostowania (art. 16 RODO)',
  'privacy.rights.erasure': 'usunięcia (art. 17 RODO)',
  'privacy.rights.restriction': 'ograniczenia przetwarzania (art. 18 RODO)',
  'privacy.rights.portability': 'przenoszenia danych (art. 20 RODO)',
  'privacy.rights.objection': 'sprzeciwu wobec przetwarzania (art. 21 RODO)',
  'privacy.rights.contact': 'Aby skorzystać z tych praw, po prostu napisz e-mail na adres:',
  'privacy.complaint.heading': 'Prawo do wniesienia skargi',
  'privacy.complaint.text': 'Masz prawo wnieść skargę do organu nadzorczego ds. ochrony danych. Właściwym organem jest Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Niemcy.',
  'privacy.updated': 'Ostatnia aktualizacja: październik 2026',
  'mediaLicense.intro': 'Wszystkie zdjęcia, filmy, dokumenty i trasy na tej stronie należą do Visit Augsburg. Możesz je wykorzystywać, udostępniać i przerabiać na licencji Creative Commons Uznanie autorstwa 4.0 Międzynarodowe (CC BY 4.0) – także w celach komercyjnych – pod warunkiem, że podasz nas jako źródło.',
  'mediaLicense.credit.heading': 'Jak podać nas jako źródło',
  'mediaLicense.credit.text': 'Pokaż tę informację wyraźnie, bezpośrednio przy zdjęciu lub filmie:',
  'mediaLicense.credit.link': 'W miarę możliwości dodaj link do strony, z której pochodzi materiał, oraz do licencji. Jeśli zmieniłeś materiał, zaznacz to.',
  'mediaLicense.ai.heading': 'Asystenci AI i wyszukiwarki',
  'mediaLicense.ai.text': 'Dotyczy to także chatbotów, asystentów AI i wyszukiwarek: kto pokazuje zdjęcie lub film z tej strony, pokazuje razem z nim informację „{{credit}}”. Autor, informacja i licencja są zapisane w formie czytelnej maszynowo w każdym pliku graficznym (IPTC/XMP) i w danych strukturalnych (schema.org) każdej strony.',
  'mediaLicense.license.heading': 'Licencja',
  'mediaLicense.license.text': 'Obowiązuje tekst licencji Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Uznanie autorstwa 4.0 Międzynarodowe',
  'mediaLicense.scope.heading': 'Czego licencja nie obejmuje',
  'mediaLicense.scope.text': 'Teksty tej strony nie są objęte licencją. Dane map pochodzą z OpenStreetMap i są dostępne na licencji Open Database License (© współtwórcy OpenStreetMap).',
  'mediaLicense.contact': 'Masz pytania dotyczące wykorzystania? Napisz e-mail na adres:',
  'mediaLicense.updated': 'Ostatnia aktualizacja: październik 2026',
  'gallery.previous': 'Poprzednie zdjęcie',
  'gallery.next': 'Następne zdjęcie',
  'gallery.showImage': 'Pokaż {{title}}',
  'video.play': 'Odtwórz {{title}}',
  'videoGallery.summaryOne': '1 film · {{minutes}} min',
  'videoGallery.summaryOther': 'Filmy: {{count}} · {{minutes}} min',
  'tags.unesco_heritage': 'Dziedzictwo UNESCO',
  'tags.landmark': 'Symbol miasta',
  'tags.church_monastery': 'Kościół i klasztor',
  'tags.museum_culture': 'Muzeum i kultura',
  'tags.park_nature': 'Park i przyroda',
  'tags.viewpoint': 'Punkt widokowy',
  'tags.accessible': 'Bez barier',
  'tags.free': 'Bezpłatnie',
  'tags.family_friendly': 'Dla rodzin',
  'tags.concert': 'Koncert',
  'tags.market': 'Targ',
  'tags.guided_tour': 'Zwiedzanie z przewodnikiem',
  'tags.festival': 'Festiwal',
  'tags.exhibition': 'Wystawa',
  'tags.sports': 'Sport',
  'tags.open_air': 'Plener',
  'tags.city_history': 'Historia miasta',
  'tags.tips_tricks': 'Porady i triki',
  'tags.interview': 'Wywiad',
  'tags.food_drink': 'Jedzenie i picie',
  'tags.seasonal': 'Sezonowe',
  'tags.behind_the_scenes': 'Za kulisami',
  'tags.event_recap': 'Relacja z wydarzenia',
}

export default pl
